import { render, staticRenderFns } from "./MainAside.vue?vue&type=template&id=e0a98438&"
import script from "./MainAside.vue?vue&type=script&lang=js&"
export * from "./MainAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports